import { useUpdateProcedureMutation } from '@services/data/procedure.api';
import { memo } from 'react';

import { ProcedureStep, ProcedureStepStateEnum } from '@/types/config/procedure.types';

import { useProcedureTabContext } from '../ProcedureTab';
import ProcedureInstructions from './ProcedureInstructions';
import StepActionButtons from './StepActionButtons';

type Props = {
  step: ProcedureStep;
  procedureId: string;
};

function EventCreationStep({ step, procedureId }: Readonly<Props>) {
  const [updateProcedure] = useUpdateProcedureMutation();
  const { canManage, notificationId } = useProcedureTabContext();
  if (!canManage) {
    return <ProcedureInstructions instructions={step.instructions} />;
  }
  return (
    <>
      <ProcedureInstructions instructions={step.instructions} />
      <StepActionButtons
        isMandatory={step.mandatory}
        procedureId={procedureId}
        stepRank={step.rank}
        onValidate={() =>
          updateProcedure({
            notificationId,
            procedureId,
            step: step.rank,
            state: ProcedureStepStateEnum.CONFIRMED,
          }).unwrap()
        }
      />
    </>
  );
}

export default memo(EventCreationStep);
